import CustomDropdownField from "../CustomDropdownField";
import { SelectProps } from "@mui/material";

interface CustomSelectProjectTypeFieldProps extends SelectProps {
  formik: any;
}

function CustomSelectProjectTypeField(
  props: CustomSelectProjectTypeFieldProps
) {
  const projectTypeList = [
    { value: "Object Detection - (CLARIFIER)", label: "Object Detection Clarifier" },
    { value: "Image Classification - (CLARIFIER)", label: "Image Classification Clarifier" },
    { value: "Instance Segmentation - (CLARIFIER)", label: "Instance Segmentation Clarifier" },
    { value: 'Semantic Segmentation - (CLARIFIER)', label: 'Semantic Segmentation Clarifier' },
    // { value: '3D-CT Object Detection - (CLARIFIER)', label: '3D-CT Object Detection Clarifier' },
    { value: '3D-CT Segmentation - (CLARIFIER)', label: '3D-CT Segmentation Clarifier' },
    // { value: 'instance_segmentation', label: 'Instance Segmentation' },
    // { value: 'panoptic_segmentation', label: 'Panoptic Segmentation' }
  ];

  return <CustomDropdownField dropdownData={projectTypeList} {...props} />;
}

export default CustomSelectProjectTypeField;
